// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('../raConstants/actionTypes');

const getDisplayNamesRequest = () => ({
    type: actionTypes.RA_PORTFOLIOS_NAME_HISTORY_GET_DISPLAY_NAMES_REQUEST,
});

const getDisplayNamesSuccess = data => ({
    type: actionTypes.RA_PORTFOLIOS_NAME_HISTORY_GET_DISPLAY_NAMES_SUCCESS,
    payload: {
        data,
    },
});

const getDisplayNamesFailure = error => ({
    type: actionTypes.RA_PORTFOLIOS_NAME_HISTORY_GET_DISPLAY_NAMES_FAILURE,
    payload: {
        error,
    },
});

const getDisplayNames = () => dispatch => {
    dispatch(getDisplayNamesRequest());

    return APIGet(dispatch, apiURLBuilder.getURL('raDisplayNames'))
        .then(response => dispatch(getDisplayNamesSuccess(response)))
        .catch(error => {
            if (error.error) {
                dispatch(getDisplayNamesFailure(error.error.description));
            } else {
                throw error;
            }
        });
};

module.exports = {
    getDisplayNames,
};
